import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import { ACTIVATION_CODE_ROUTE, AUTH_PASSWORD_ROUTE, CONTROL_KITCHEN_ROUTE, CREATE_PASSWORD_ROUTE, FORGOT_PASSWORD_ROUTE, getAsRoute, LOGIN_ROUTE, PURCHASES_ROUTE, OFFICE_MANAGER_ROUTE, MERCHANT_ROUTE, ROOT_ROUTE, ACCESS_DENIED_ROUTE, PROFILE_ROUTE, NEWS_ROUTE, ERROR_ROUTE, MERCHANT_ADMIN_ROUTE, MERCHANT_NEWS_ROUTE, MERCHANT_CREATE_NEWS_ROUTE, INVITATION_ROUTE, SETTINGS_ROUTE, SURVEY_ROUTE, MERCHANT_REPORTS_ROUTE, ROLLUP_GRAPH_EXAMPLE_ROUTE } from '../../constants/routes';
import { ForgotPassword } from '../../modules/login/pages/ForgotPassword';
import { SignInWithActivationCode } from '../../modules/login/pages/SignInWithActivationCode';
import { CreatePassword } from '../../modules/login/pages/CreatePassword';
import { Authenticated } from '../../modules/security/components/Authenticated';
import { ControlKitchen } from '../../modules/merchant/merchant/pages/ControlKitchen';
import { ErrorPage } from './pages/ErrorPage';
import { OfficeHome } from '../../modules/office/pages/OfficeHome';
import { MerchantReportsHome } from '../../modules/merchant/merchant/pages/MerchantReportsHome';
import { Root } from '../../modules/root/pages/Root';
import { AccessDeniedPage } from '../../modules/security/pages/AccessDenied';
import { RequireUserType } from '../../modules/security/components/RequireUserType';
import { NotFoundPage } from './pages/NotFoundPage';
import { Profile } from '../../modules/profil/pages/Profile';
import { Layout } from '../../shared/layouts/Layout';
import { NewsPage } from '../../modules/news/pages/NewsPage';
import { Purchases } from '../../modules/office/pages/Purchases';
import { StartPageLayout } from '../../modules/login/StartPageLayout';
import { SignInWithPassword } from '../../modules/login/pages/SignInWithPassword';
import { SignInWithUserName } from '../../modules/login/pages/SignInWithUserName';
import { UserType } from '../../modules/login/loginTypes';
import { RouteErrorHandler } from '../../shared/components/errors/RouteErrorHandler';
import { CreateOrEditMerchantArticle } from '../../modules/merchant/admin/news/pages/CreateOrEditMerchantArticle';
import { Invitation } from '../../modules/login/pages/Invitation';
import { Settings } from '../../modules/settings/pages/Settings';
import { Survey } from '../../modules/merchant/admin/survey/pages/Survey';
import { MerchantAdminHome } from '../../modules/merchant/admin/news/pages/MerchantAdminHome';
import { MerchantNews } from '../../modules/merchant/admin/news/pages/MerchantNews';
import { RollupGraphExample } from '../../modules/merchant/merchant/pages/RollupGraphExample';
import { MerchantHome } from '../../modules/merchant/merchant/pages/MerchantHome';


// Get base from HTML base element in index.html - and thereby %PUBLIC_URL%
// This will adjust all routes for the subfolder the app is deployed to
const baseAttr = document.querySelector("base")?.getAttribute("href") ?? "/"

// NOTE: Need to remove trailing slash if we have a path
const basename = (baseAttr.length > 1 && baseAttr.endsWith("/")) ? baseAttr.substring(0, baseAttr.length - 1) : baseAttr

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path={ROOT_ROUTE} element={(<Root />)} />

            <Route path={LOGIN_ROUTE} element={(<StartPageLayout />)}>
                <Route
                    index
                    element={<SignInWithUserName />}
                />

                <Route
                    element={<SignInWithPassword />}
                    path={getAsRoute(LOGIN_ROUTE, AUTH_PASSWORD_ROUTE)}
                />

                <Route
                    element={<ForgotPassword />}
                    path={getAsRoute(LOGIN_ROUTE, FORGOT_PASSWORD_ROUTE)}
                />

                <Route
                    element={<SignInWithActivationCode />}
                    path={getAsRoute(LOGIN_ROUTE, ACTIVATION_CODE_ROUTE)}
                />

                <Route
                    element={<CreatePassword />}
                    path={getAsRoute(LOGIN_ROUTE, CREATE_PASSWORD_ROUTE)}
                />
            </Route>

            <Route path={INVITATION_ROUTE} element={<Invitation />} />

            <Route
                element={(
                    <Authenticated>
                        <Layout />
                    </Authenticated>
                )}
                errorElement={<RouteErrorHandler />}
            >
                <Route path={OFFICE_MANAGER_ROUTE} element={(<RequireUserType userType={UserType.OFFICE_MANAGER} />)}>
                    <Route index element={(<OfficeHome />)} />
                    <Route path={getAsRoute(OFFICE_MANAGER_ROUTE, PURCHASES_ROUTE)} element={(<Purchases />)} />
                </Route>

                <Route path={MERCHANT_ROUTE} element={(<RequireUserType userType={UserType.MERCHANT} />)}>
                    <Route index element={(<MerchantHome />)} />

                    <Route path={getAsRoute(MERCHANT_ROUTE, MERCHANT_ADMIN_ROUTE)} >
                        <Route index element={(<MerchantAdminHome />)} />
                        <Route path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_NEWS_ROUTE)} element={(<MerchantNews />)} />
                        <Route path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_CREATE_NEWS_ROUTE)} element={(<CreateOrEditMerchantArticle />)} />

                    </Route>

                    <Route path={getAsRoute(MERCHANT_ROUTE, MERCHANT_REPORTS_ROUTE)} >
                        <Route index element={(<MerchantReportsHome />)} />
                        <Route path={getAsRoute(MERCHANT_REPORTS_ROUTE, CONTROL_KITCHEN_ROUTE)} element={(<ControlKitchen />)} />
                        <Route path={getAsRoute(MERCHANT_REPORTS_ROUTE, SURVEY_ROUTE)} element={(<Survey />)} />
                        <Route path={getAsRoute(MERCHANT_REPORTS_ROUTE, ROLLUP_GRAPH_EXAMPLE_ROUTE)} element={(<RollupGraphExample />)} />
                    </Route>


                </Route>

                <Route path={PROFILE_ROUTE} element={(<Profile />)} />
                <Route path={SETTINGS_ROUTE} element={(<Settings />)} />
                <Route path={NEWS_ROUTE} element={(<NewsPage />)} />
            </Route >

            <Route path={ACCESS_DENIED_ROUTE} element={(<AccessDeniedPage />)} />

            < Route path={ERROR_ROUTE} element={(<ErrorPage />)} />

            < Route path="*" element={(<NotFoundPage />)} />
        </>
    ), {
        basename
    }
);
